import { render } from "./NewPlatform.vue?vue&type=template&id=454801ba&scoped=true"
import script from "./NewPlatform.vue?vue&type=script&lang=js"
export * from "./NewPlatform.vue?vue&type=script&lang=js"

import "./NewPlatform.vue?vue&type=style&index=0&id=454801ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454801ba"]])

export default __exports__